import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"
import AnimeButton from "../components/AnimeButton"

const WhiteButton = styled(Button)`
  width: 173px;
  height: 34px;
  margin: auto;
  border: 1px solid #6e6e6e;
  text-align: center;
  border-radius: 0;
`

function SpProduct() {
  const data = useStaticQuery(graphql`
    query {
      sp_product: file(relativePath: { eq: "sp_product.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Box>
        <Box width="100%">
          <Img fluid={data.sp_product.childImageSharp.fluid} />
          <Box
            width="100%"
            bgcolor="#909090"
            textAlign="center"
            mb={"10%"}
            pb={"5%"}
            pt={"10%"}
          >
            <WrapTypo
              fs="18px"
              isHunter={true}
              color="#fff"
              style={{ marginLeft: "0", marginTop: "10%" }}
            >
              PRODUCT
            </WrapTypo>

            <Box width="80%" textAlign="left" mt="8%" mb="15%" mx={"auto"}>
              <WrapTypo fs="12px" lh="200%" color="#fff">
                UNFILTER Treatment bath oilはお風呂に入れるだけで
                全身を美容液に浸すような新感覚のスキンケアが味わえるトリートメントバスオイルです。
                <br />
                <br />
                1ヶ月、週2日の集中プログラムで心と体のフィルターを取り除き、艶と香りを纏うあなたへ
              </WrapTypo>
            </Box>
            <Box width="clamp(120px,13vw,250px)" my={"10%"} mx={"auto"}>
              <AnimeButton
                href="/product/"
                text="詳しく見る"
                width="clamp(120px,13vw,250px)"
                height="clamp(30px,2.5vw,50px)"
                fs="clamp(12px,1.2vw,24px)"
                color="#fff"
                border="solid 1px #fff"
                bgColor="#565656"
                afterColor="#565656"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default SpProduct
